import React, { Component } from "react";
import FadeIn from "react-fade-in";
import Lottie from "react-lottie";
import "bootstrap/dist/css/bootstrap.css";
import * as animationData from "../../animations/woman-blink.json";
import * as doneData from "../../animations/success.json";
import { connect } from "react-redux";
import LayoutPicker from "../Layouts/LayoutPicker";

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData.default,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};
const defaultOptions2 = {
  loop: false,
  autoplay: true,
  animationData: doneData.default,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

class Loading extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: undefined,
      done: undefined,
    };
  }
  componentDidMount() {
    setTimeout(() => {
      this.props.dispatch({
        type: "SET_LESSON_DATA",
        payload: this.props.activeLesson.id,
      });

      // set all of the scenes in the redux state

      this.setState({ loading: true });
      setTimeout(() => {
        this.setState({ done: true });
        // get the first item in the hashtable we just created to start the lesson.
        this.props.dispatch({
          type: "SET_ACTIVE_SCENE",
          payload: this.props.lessonData[1],
        });
      }, 3000);
    }, 2000);
  }

  render() {
    return (
      <div>
        {!this.state.done ? (
          <div className="black-screen">
            <FadeIn>
              <div className="d-flex justify-content-center align-items-center animate-float">
                <h1>loading lesson</h1>
                {!this.state.loading ? (
                  <Lottie options={defaultOptions} height={120} width={120} />
                ) : (
                  <Lottie options={defaultOptions2} height={120} width={120} />
                )}
              </div>
            </FadeIn>
          </div>
        ) : (
          <LayoutPicker history={this.props.history} />
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  lessonData: state.lessonData,
  activeLesson: state.activeLesson,
});
export default connect(mapStateToProps)(Loading);
